<div class="eforall-common-field form-floating">

	@let currentField = field();
	@let state = currentField.formField();
	@let validations = currentField.validations;

	<div class="input-group">
		<div class="eforall-common-field form-floating">
			<input type="text" class="form-control" #addressField
				[id]="randomId"
				[placeholder]="displayLabel()"
				autocomplete="new-google-address"
				[value]="state.value()?.placeAddress ?? ''"
				(input)="onInputChange($event.target.value)"
				[disabled]="state.disabled()"
				(blur)='onBlur()'
				(keydown)="onKeyDown($event)">

			<label [for]="randomId" class="color-gray d-flex w-100">
				{{ displayLabel() }}
				@if (!validations || !validations.isRequired?.()) {
				<span class="ps-1">(optional)</span>
				}
			</label>

			<!-- Suggestions Dropdown -->
			@if(suggestions().length){
			<ul class="list-group position-absolute w-100 shadow">
				@for(s of suggestions(); track $index; let i = $index){
				<!-- preventDefault for mouseDown - keeps input focused -->
				<li class="list-group-item list-group-item-action"
					[class.active]="i === highlighted()" (mousedown)="$event.preventDefault()" (mouseenter)="highlighted.set(i)" (click)="onAddressSelection(s)">
					{{ s.placePrediction?.text?.text }}
				</li>
				}
			</ul>
			}
		</div>
	</div>

	@if (state.touched() && state.invalid()) {
	<div class="error-message" role="alert">
		@for (error of state.errors(); track error) {
		<div class="color-darkred text-end" style="font-size: 14px">{{ error.message }}</div>
		}
	</div>
	}
</div>